module.exports = __webpack_public_path__ + "static/media/app-store-badge.2928664f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/app-store-badge.svg
// module id = 584
// module chunks = 11